import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-[#1A2B4A] text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-[#D4AF37] rounded-lg flex items-center justify-center">
                <i className="ri-home-heart-line text-white text-xl"></i>
              </div>
              <span className="text-xl font-bold">SafeStay Solutions</span>
            </div>
            <p className="text-white/70 text-sm leading-relaxed mb-6">
              Making homes safer and more accessible for seniors across Massachusetts since 2021.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-[#D4AF37] rounded-full flex items-center justify-center transition-colors cursor-pointer" aria-label="Facebook">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-[#D4AF37] rounded-full flex items-center justify-center transition-colors cursor-pointer" aria-label="Instagram">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-[#D4AF37] rounded-full flex items-center justify-center transition-colors cursor-pointer" aria-label="LinkedIn">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Company</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => navigate('/why-choose-us')} className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm cursor-pointer">
                  Why Choose Us
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/services')} className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm cursor-pointer">
                  Our Services
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/packages')} className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm cursor-pointer">
                  Packages
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Contact</h3>
            <ul className="space-y-3">
              <li>
                <a href="tel:6175396650" className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm flex items-center gap-2 cursor-pointer">
                  <i className="ri-phone-line"></i>
                  (617) 539-6650
                </a>
              </li>
              <li>
                <a href="mailto:safestayma@gmail.com" className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm flex items-center gap-2 cursor-pointer break-all">
                  <i className="ri-mail-line"></i>
                  safestayma@gmail.com
                </a>
              </li>
              <li className="text-white/70 text-sm flex items-start gap-2">
                <i className="ri-map-pin-line mt-1"></i>
                <span>Serving North Shore & Greater Boston Area</span>
              </li>
            </ul>
          </div>

          {/* CTA */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Get Started</h3>
            <p className="text-white/70 text-sm mb-4">
              Schedule your free home safety assessment today.
            </p>
            <button
              onClick={() => navigate('/free-assessment')}
              className="w-full bg-[#D4AF37] hover:bg-[#C4A137] text-[#1A2B4A] px-6 py-3 rounded-full font-semibold text-sm transition-colors cursor-pointer whitespace-nowrap"
            >
              Free Assessment
            </button>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-white/60">
            <p>© 2024 SafeStay Solutions, A subsidiary of MH Renovation Services. All rights reserved.</p>
            <div className="flex gap-6">
              <a href="#" className="hover:text-[#D4AF37] transition-colors cursor-pointer">Privacy Policy</a>
              <a href="#" className="hover:text-[#D4AF37] transition-colors cursor-pointer">Terms of Service</a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-[#D4AF37] transition-colors cursor-pointer">Website Builder</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
